import { withAuthRedirect } from '../hocs';
import { Panel, PanelHeader, PanelContent, PrimaryButton } from '../atoms';
import { AccountsList } from '../organisms';
import { useContext } from 'react';
import { UserContext } from '../../contexts';

const AccountsPage = () => {
  const { user, originalUser, onUserChange } = useContext(UserContext);

  const revertToOriginalMerchantIdInContext = () => {
    onUserChange({
      merchantId: originalUser.merchantId,
      userType: originalUser.userType,
      sub: user.sub,
      email: user.email
    });
  };

  return (
    <Panel>
      <PanelHeader>
        <h1>Accounts</h1>
        {originalUser.merchantId !== user.merchantId && (
          <PrimaryButton
            type="button"
            onClick={(e: any) => {
              e.stopPropagation();
              revertToOriginalMerchantIdInContext();
            }}
          >
            Become Platform
          </PrimaryButton>
        )}
      </PanelHeader>
      <PanelContent>
        <AccountsList />
      </PanelContent>
    </Panel>
  );
};

const SecureAccountsPage = withAuthRedirect(AccountsPage);
export { SecureAccountsPage as AccountsPage };
